import { FC } from 'react';

import Section from 'components/Section';
import Stack from '@mui/material/Stack';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from 'components/TextField';
import TwoColumn from 'components/TwoColumn';
import PercentInput from 'components/PercentInput';
import PriceInput from 'components/PriceInput';
import RangeSelector from 'components/RangeSelector';

const GeneralSettingsEditFormGeneral: FC = () => (
  <Section id="general" title="Bendra informacija">
    <Stack spacing={4}>
      <TwoColumn
        left={
          <TextField
            fullWidth
            name="standardMarkupAdult"
            component={PercentInput}
            label="Standartinis antkainis suaugusiam"
          />
        }
        right={
          <TextField
            fullWidth
            name="standardMarkupChild"
            component={PercentInput}
            label="Standartinis antkainis vaikui 2-12m."
          />
        }
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="infantTripPrice"
            component={PriceInput}
            label="Kelionės kaina vaikui iki 2m."
          />
        }
        right={
          <TextField
            fullWidth
            name="advancePayment"
            component={PriceInput}
            label="Standartinis avanso priedas prie skrydžio kainos"
          />
        }
      />

      <TextField
        fullWidth
        name="defaultTransferPrice"
        label="Standartinė pervežimo iš oro uosto kaina"
        component={PriceInput}
      />

      <TextField
        fullWidth
        name="descriptionTitle"
        label="Standartinė aprašymo antraštė"
      />

      <TextField
        fullWidth
        name="notesTitle"
        label="Standartinė pastabų antraštė"
      />

      <RangeSelector
        name="durationRanges"
        label="Trukmės (naktų) intervalai pasiūlymų paieškoje"
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="revalidateStaticContent"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">sek.</InputAdornment>
              ),
            }}
            label="Pergeneruoti statinius puslapius po"
          />
        }
        right={
          <TextField
            fullWidth
            name="cancelOrdersAfterMinutes"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">min.</InputAdornment>
              ),
            }}
            label="Laikas, po kurio yra atšaukiami neapmokėti užsakymai"
          />
        }
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="autosaveDelay"
            InputProps={{
              endAdornment: <InputAdornment position="end">ms.</InputAdornment>,
            }}
            label="Automatiškai išsaugoti užsakymą po"
          />
        }
        right={
          <TextField
            fullWidth
            name="priceCheckerLimit"
            label="Skrydžio kainos tikrinimo limitas"
          />
        }
      />

      <TextField
        fullWidth
        name="adminEmailErrors"
        label="El. paštai klaidų pranešimams"
      />

      <TextField
        fullWidth
        name="adminEmailNewsSubscribers"
        label="El. paštai naujienlaiškių registracijoms"
      />

      <TextField
        fullWidth
        name="adminEmailOrders"
        label="El. paštai užsakymams"
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="abandonedCheckoutTimeout"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">min.</InputAdornment>
              ),
            }}
            label="Užsakymus apleisti po"
          />
        }
        right={
          <TextField
            fullWidth
            name="orderCleanupAge"
            InputProps={{
              endAdornment: <InputAdornment position="end">d.</InputAdornment>,
            }}
            label="Trinti apleistus užsakymus po"
          />
        }
      />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormGeneral;
